import { ReactComponent as BkgComponent } from '../assets/bkg.svg';
import SvgRouteNavigator from '../components/SvgRouteNavigator';

const linkRoutes: Record<string, string> = {
  "link-inf": "/info",
  "link-umenie": "/uak",
  "link-mix": "/misc",
  "link-trieda": "/myclass",
  "link-sp": "/cas",
  "link-pr": "/cap",
  "link-mat": "/maths",
  "link-slj": "/slovak",
};

function Main() {
  return <SvgRouteNavigator SvgComponent={BkgComponent} linkRoutes={linkRoutes} containerClassName="page-main-bkg" />;
}

export default Main;